import { Component, Input, OnInit } from '@angular/core';
import { environment } from './../../../../environments/environment';

@Component({
	selector: 'app-cig-implement',
	templateUrl: './cig-implement.component.html',
	styleUrls: ['./cig-implement.component.scss']
})
export class CigImplementComponent implements OnInit {

	@Input() foursightassets;
	@Input() author;
	@Input() slides;
	public env;

	constructor() { }

	ngOnInit() {
		this.env=environment;
	}

}
